import { i18n } from '@src/configs/i18n.configs';

export const showSorryNoWorriesAlert = (
  text: string = i18n.t('default:navigator.noWorries'),
) => {
  alert(i18n.t('default:navigator.sorry') + '\n' + text);
};
